// ----------------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//        Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------------
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class Provider {
    register(service) {
        return service.addProvider(this);
    }
    enableProbe(probeName, service, action) {
        let ecb = {
            service: service,
            action: action
        };
        if (!this.enabling[probeName]) {
            this.enabling[probeName] = [];
        }
        this.enabling[probeName].push(ecb);
        return true;
    }
    disableProbe(probeName) {
        this.enabling[probeName] = undefined;
    }
    probe(name, context) {
        let enablings = this.enabling[name];
        if (enablings) {
            for (let enabling of enablings){
                enabling.action(name, enabling.service, context);
            }
        }
    }
    constructor(name, instrumentService){
        _define_property(this, "name", void 0);
        _define_property(this, "namedProbe", void 0);
        _define_property(this, "enabling", void 0);
        this.name = name;
        if (instrumentService) {
            this.register(instrumentService);
        }
        this.enabling = {};
    }
}
